import { Typography } from "antd";

const { Title, Paragraph, Text } = Typography;

export default function PrivacyPolicyPage() {
  return (
    <div style={{ maxWidth: 800, margin: "0 auto", padding: "32px 24px" }}>
      <Typography>
        <Title level={1}>Privacy Policy</Title>
        <Paragraph type="secondary">Last updated: April 23, 2026</Paragraph>

        <Paragraph>
          This Privacy Policy describes how <Text strong>Bits2b s.r.o.</Text> ("we", "us", or "our")
          collects, uses, and shares your information when you use <Text strong>Spotlight</Text> ("App")
          and its integration with WhatsApp Business API.
        </Paragraph>

        <Title level={2}>1. Information We Collect</Title>
        <Paragraph>When you use our App, we may collect the following information:</Paragraph>
        <ul>
          <li><Text strong>Account Information:</Text> Name, email address, and phone number.</li>
          <li>
            <Text strong>WhatsApp Data:</Text> Phone numbers of your contacts, message content, and
            metadata (timestamps, delivery status) sent or received through our App via the WhatsApp
            Business API.
          </li>
          <li>
            <Text strong>Usage Data:</Text> Information about how you interact with our App.
          </li>
        </ul>

        <Title level={2}>2. How We Use Your Information</Title>
        <Paragraph>We use the collected information to:</Paragraph>
        <ul>
          <li>Provide, operate, and maintain our App.</li>
          <li>Enable messaging functionality via the WhatsApp Business API.</li>
          <li>Manage your contacts and groups within our App.</li>
          <li>Provide customer support and respond to your inquiries.</li>
        </ul>

        <Title level={2}>3. How We Share Your Information</Title>
        <Paragraph>
          We do not sell your personal information. We may share your information with:
        </Paragraph>
        <ul>
          <li>
            <Text strong>Meta Platforms, Inc.:</Text> As required to provide the WhatsApp Business API
            functionality. Your data is also subject to Meta's Privacy Policy.
          </li>
          <li>
            <Text strong>Service Providers:</Text> Third-party vendors who assist us in operating our
            App (e.g., hosting providers).
          </li>
          <li>
            <Text strong>Legal Requirements:</Text> If required by law, regulation, or legal process.
          </li>
        </ul>

        <Title level={2}>4. Data Security</Title>
        <Paragraph>
          We implement reasonable security measures to protect your information from unauthorized
          access, alteration, disclosure, or destruction. However, no method of transmission over the
          Internet or electronic storage is 100% secure.
        </Paragraph>

        <Title level={2}>5. Data Deletion</Title>
        <Paragraph>
          You have the right to request the deletion of your personal data. To request data deletion,
          please contact us at <Text strong>saas@bits2b.com</Text> or follow the instructions in our
          App.
        </Paragraph>

        <Title level={2}>6. Changes to This Privacy Policy</Title>
        <Paragraph>
          We may update this Privacy Policy from time to time. We will notify you of any changes by
          posting the new Privacy Policy on this page.
        </Paragraph>

        <Title level={2}>7. Contact Us</Title>
        <Paragraph>
          If you have any questions about this Privacy Policy, please contact us at:
        </Paragraph>
        <Paragraph>
          <Text strong>Email:</Text> saas@bits2b.com
          <br />
          <Text strong>Website:</Text>{" "}
          <a href="https://bits2b.com" target="_blank" rel="noopener noreferrer">
            bits2b.com
          </a>
        </Paragraph>
      </Typography>
    </div>
  );
}
